var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"shop__tabs"},[_c('ul',{staticClass:"tabs__list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.route,staticClass:"tabs__item",class:{
                'tabs__item--active': _vm.isActive(item),
                'tabs__item--disabled': item.disabled,
            },style:({
                width: `${100 / _vm.items.length}%`,
            }),on:{"click":function($event){return _vm.navigate(item)}}},[_c('i',{staticClass:"tabs__icon oti",class:`oti-${item.icon}`}),_c('span',{staticClass:"tabs__label ot-text-body"},[_vm._v(_vm._s(item.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }